import React from 'react';
import CommonSlider from './partials/commonslider';

const Lounge = () => {
  return (
    <main className="petti_f_bg">
      <CommonSlider/>

      <div className="container margin_120_95">
        <div className="row_list_version_2">
          <div className="row g-0 align-items-center">
            <div className="col-xl-8">
              <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                <div className="item">
                  <a data-fslightbox="gallery_1" data-type="image" href="/assets/img/lounge/1.webp">
                    <img src="/assets/img/lounge/1.webp" alt="Sun Beds" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_1" data-type="image" href="/assets/img/lounge/1-1.webp">
                    <img src="/assets/img/lounge/1-1.webp" alt="Sun Beds" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_1" data-type="image" href="/assets/img/lounge/1-2.webp">
                    <img src="/assets/img/lounge/1-2.webp" alt="Sun Beds" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_1" data-type="image" href="/assets/img/lounge/1-3.webp">
                    <img src="/assets/img/lounge/1-3.webp" alt="Sun Beds" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="box_item_info round_border" data-jarallax-element="-25">
                <h2>Sun Beds</h2>
                <p>Relax on a plush sun bed, sip cocktails, and soak up the sun's warmth by the shore.</p>
                <div className="box_item_footer d-flex align-items-center justify-content-between">
                  <a href="https://wa.me/94761407881?text=I'm%20interested%20in%20reserving%20a%20sun%20bed" target="_blank" rel="noopener noreferrer" className="btn_4 learn-more">
                    <span className="circle">
                      <span className="icon arrow"></span>
                    </span>
                    <span className="button-text">Enquire Now</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row_list_version_2 inverted">
          <div className="row g-0 align-items-center">
            <div className="col-xl-8 order-xl-2">
              <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                <div className="item">
                  <a data-fslightbox="gallery_2" data-type="image" href="/assets/img/lounge/2.webp">
                    <img src="/assets/img/lounge/2.webp" alt="Lounges" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_2" data-type="image" href="/assets/img/lounge/2-1.webp">
                    <img src="/assets/img/lounge/2-1.webp" alt="Lounges" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_2" data-type="image" href="/assets/img/lounge/2-2.webp">
                    <img src="/assets/img/lounge/2-2.webp" alt="Lounges" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="box_item_info round_border" data-jarallax-element="-25">
                <h2>Lounges</h2>
                <p>Relax in our beachside lounge, savoring drinks and laughter with loved ones, amidst tranquil waves.</p>
                <div className="box_item_footer d-flex align-items-center justify-content-between">
                  <a href="https://wa.me/94761407881?text=I'm%20interested%20in%20reserving%20a%20lounge" target="_blank" rel="noopener noreferrer" className="btn_4 learn-more">
                    <span className="circle">
                      <span className="icon arrow"></span>
                    </span>
                    <span className="button-text">Enquire Now</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row_list_version_2">
          <div className="row g-0 align-items-center">
            <div className="col-xl-8">
              <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                <div className="item">
                  <a data-fslightbox="gallery_3" data-type="image" href="/assets/img/lounge/3.webp">
                    <img src="/assets/img/lounge/3.webp" alt="Cabanas" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_3" data-type="image" href="/assets/img/lounge/3-1.webp">
                    <img src="/assets/img/lounge/3-1.webp" alt="Cabanas" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_3" data-type="image" href="/assets/img/lounge/3-2.webp">
                    <img src="/assets/img/lounge/3-2.webp" alt="Cabanas" />
                  </a>
                </div>
                <div className="item">
                  <a data-fslightbox="gallery_3" data-type="image" href="/assets/img/lounge/3-3.webp">
                    <img src="/assets/img/lounge/3-3.webp" alt="Cabanas" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="box_item_info round_border" data-jarallax-element="-25">
                <h2>Cabanas</h2>
                <p>Relaxing by waves, sipping cocktails, sun-kissed serenity, cabana bliss unfolds.</p>
                <div className="box_item_footer d-flex align-items-center justify-content-between">
                  <a href="https://wa.me/94761407881?text=I'm%20interested%20in%20reserving%20a%20cabana" target="_blank" rel="noopener noreferrer" className="btn_4 learn-more">
                    <span className="circle">
                      <span className="icon arrow"></span>
                    </span>
                    <span className="button-text">Enquire Now</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Lounge;

